export enum AccessLevel {
	None = 'None',
	Admin = 'Admin'
}
